var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      staticClass: "big no-padding-confirm",
      attrs: {
        closeIcon: true,
        showMask: true,
        title: _vm.title,
        close: _vm.close
      }
    },
    [
      _c("wallet-table", {
        staticClass: "trade-list-table",
        attrs: { headList: _vm.heads, contentList: _vm.list }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }